export default __webpack_public_path__ + "7c18498.png";